import '../scss/main.scss';

$(document).ready(function() {
    // トップ表示アニメーション実装
    $('.right_text').delay(1500).queue(function (next) {
        $(this).addClass('fade-in');
        next();
    });
    $('.left_text').delay(2500).queue(function (next) {
        $(this).addClass('fade-in');
        next();
    });
    $('.kv_slider').delay(500).queue(function (next) {
        $(this).addClass('fade-in');
        next();
    }).queue(function (next) {
        $(this).slick({
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
        });
        next();
    });

    // 私たちの思い　画像表示処理
    const $underInElements = $('.top-under-in');
    const checkElementsInViewport = () => {
        $underInElements.each(function () {
            const $element = $(this);
            const elementTop = $element.offset().top;
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            if (scrollTop + windowHeight > elementTop) {
                $element.addClass('active');
            }
        });
    };
    checkElementsInViewport();
    $(window).on('scroll', checkElementsInViewport);
});